import axiosInstance from '@/api/axiosInstance';
import { FetchBundleResponse } from '../types';

/**
 * Fetch single program details
 */
export async function fetchBundle(bundleId: string): Promise<FetchBundleResponse> {
  const response = await axiosInstance.get<FetchBundleResponse>(`/api/programs/${bundleId}`);
  return response.data;
}

export default fetchBundle;
